import _ from 'lodash';
import IApplicationState from 'app/types/state';
import { parseAmount, toTitleCase, friendlyDate } from 'app/utils/parsers';

function mapSelect(connectionRuns, n) {
  const sa = connectionRuns.connectionRunsById[n];
  if (sa) {
    return { id: sa.id, name: sa.name };
  }
  return null;
}

export function getConnectionRunsByIdInSelectFormat(connectionRuns): any {
  return _.map(connectionRuns.connectionRunIds, (n) => mapSelect(connectionRuns, n));
}

export function getCurrentConnectionRun(state: IApplicationState): any {
  if (
    state.connectionRuns.connectionRunsById !== undefined
    && state.connectionRuns.currentConnectionRunId !== undefined
  ) {
    const findConnectionRun = state.connectionRuns.connectionRunsById[
      state.connectionRuns.currentConnectionRunId
    ];
    const currentConnectionRun = {
      ...findConnectionRun,
    };

    return currentConnectionRun;
  }
  return {};
}

export function getCurrentFormConnectionRun(state: IApplicationState) {
  return {
    ...getCurrentConnectionRun(state),
    ...state.connectionRuns.requestedData,
  };
}

export function getConnectionRuns(state: IApplicationState): any {
  return {
    ...state.connectionRuns,
    currentConnectionRun: {
      ...getCurrentConnectionRun(state),
    },
  };
}

export function getConnectionRunsByTeamId(state, teamId): any {
  if (state.connectionRuns.connectionRunsById !== undefined && teamId != null) {
    return _.filter(state.connectionRuns.connectionRunsById, { teamId });
  }
  return {};
}

export function getConnectionRunsByIds(connectionRunsById, tagIds): any {
  if (connectionRunsById !== undefined && tagIds != null) {
    return _.pick(connectionRunsById, tagIds);
  }
  return {};
}

export function getConnectionRunIdsByTeamId(state, teamId): any {
  if (state.connectionRuns.connectionRunsById !== undefined && teamId != null) {
    const filtered = _.filter(state.connectionRuns.connectionRunsById, {
      teamId,
    });
    if (filtered != null) {
      return _.map(filtered, 'id');
    }
    return [];
  }
  return [];
}

function parseConnectionRunStatusText(connectionRun) {
  let parsedText = _.capitalize(connectionRun.status);
  if (_.isEmpty(connectionRun.status)) {
    parsedText = 'Pending';
  }
  return parsedText;
}

function parseConnectionRunStatusColour(connectionRun) {
  let parsedColour = 'grey';
  if (connectionRun.status === 'completed') {
    parsedColour = 'green';
  }
  return parsedColour;
}

function parseConnectionRunStatus(status) {
  const statuses = [];
  const colour = parseConnectionRunStatusColour(status);
  const text = parseConnectionRunStatusText(status);

  statuses.push({ colour, text });

  return statuses;
}

export function getConnectionRunSummary(connectionRun): any {
  const connectionRunSummary = {
    id: connectionRun.id,
    status: parseConnectionRunStatus(connectionRun.status),
    name: connectionRun.name,
    createdAt: friendlyDate(connectionRun.createdAt),
  };
  return connectionRunSummary;
}
